import React, { MouseEventHandler, useEffect, useState } from 'react'
import {
  getSite,
  getRecentEvents,
  getRecentEventsFromRegion,
} from '../../model'

import { Stack, Grid, Typography, Card, CardActionArea } from '@mui/material'
import { EventViewModel } from '../ViewModel'
import { useAppNavigate } from '../../Paths'
import { useAuth } from '../Auth'

function GeneralDashboardPage() {
  const [events, setEvents] = useState<EventViewModel[]>([])
  const appNavigate = useAppNavigate()

  const { currentUser } = useAuth()

  useEffect(() => {
    let unsubscribed = false
    if (unsubscribed) return

    initialize()

    return () => {
      unsubscribed = true
    }
  }, [])

  async function initialize() {
    const regions_accessed = currentUser.role.regions_accessed

    let recentEventsData: EventViewModel[] = []
    if (regions_accessed.length === 0) {
      recentEventsData = await getRecentEvents(9)
    } else {
      recentEventsData = await getRecentEventsFromRegion(regions_accessed, 9)
    }
    setEvents(recentEventsData)
  }

  return (
    <Stack spacing={2} padding={2} flexGrow={1}>
      <Typography color="black" variant="h4">
        Recent Events
      </Typography>
      {currentUser.role.regions_accessed.length !== 0 ? (
        <Stack>
          <Typography color="black" variant="h6">
            {currentUser.role.regions_accessed.join(', ')}
          </Typography>
          <Grid
            container
            spacing={{ xs: 1, md: 1 }}
            justifyContent={{
              xs: 'center',
              lg: 'space-between',
            }}
          >
            {events.map((event, index) => (
              <Grid
                item
                xs={11}
                sm={5.8}
                md={5.8}
                lg={3.8}
                key={index}
                display="flex"
                flexDirection={'column'}
              >
                <EventCard
                  event={event}
                  onClick={(e) => {
                    console.log(`Event clicked: ${event.id}`)
                    appNavigate.toEvent(event.siteCode, event.id)
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Stack>
      ) : (
        <Grid
          container
          spacing={{ xs: 1, md: 1 }}
          justifyContent={{
            xs: 'center',
            lg: 'space-between',
          }}
        >
          {events.map((event, index) => (
            <Grid
              item
              xs={11}
              sm={5.8}
              md={5.8}
              lg={3.8}
              key={index}
              display="flex"
              flexDirection={'column'}
            >
              <EventCard
                event={event}
                onClick={(e) => {
                  console.log(`Event clicked: ${event.id}`)
                  appNavigate.toEvent(event.siteCode, event.id)
                }}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Stack>
  )
}

interface EventCardProps {
  event: EventViewModel
  onClick: MouseEventHandler
}
function EventCard({ event, onClick }: EventCardProps) {
  const [siteName, setSiteName] = useState('')

  useEffect(() => {
    const site = getSite(event.siteCode)
    if (site != null) setSiteName(() => site.siteName)
  }, [event.siteCode])

  return (
    <Card sx={{ height: '100%' }}>
      <CardActionArea onClick={onClick}>
        <Stack p={2} spacing={1}>
          <Typography gutterBottom variant="h6" component="div">
            {siteName ?? event.siteCode}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {event.creationDate} {event.timeOfRecord}
          </Typography>
          <Stack direction={'row'} justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              {event.waterTemp}˚C
            </Typography>
            <Typography variant="body2" color="text.secondary">
              pH: {event.pH}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              EC: {event.EC} µs/cm
            </Typography>
          </Stack>
        </Stack>
      </CardActionArea>
    </Card>
  )
}

export default GeneralDashboardPage
